import { render } from "./ProjectStretchGoals.vue?vue&type=template&id=7b6cedc0"
import script from "./ProjectStretchGoals.vue?vue&type=script&lang=js"
export * from "./ProjectStretchGoals.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__